module.exports = __webpack_public_path__ + "static/media/background.1f7c5980.png";